/**
 * Uint8 constants
 *
 * @see https://voltaire.tevm.sh/primitives/uint8 for Uint8 documentation
 * @since 0.0.0
 */

/** @type {import('./Uint8Type.js').Uint8Type} */
export const MIN = /** @type {any} */ (0);

/** @type {import('./Uint8Type.js').Uint8Type} */
export const MAX = /** @type {any} */ (255);

/** @type {import('./Uint8Type.js').Uint8Type} */
export const ZERO = /** @type {any} */ (0);

/** @type {import('./Uint8Type.js').Uint8Type} */
export const ONE = /** @type {any} */ (1);

/** @type {number} */
export const SIZE = 8;
